import { SORT_BY, TRAINING_STEP, OECTrainingStatus, OECRetrainStepProgress, OECDiscardKeywordGenerationModal, OECDiscardKeywordsModal, FILTER_BY_TAGGED_STATUS } from '../types';
import { RESPONSE_PAGE_SIZE } from '../constants';
export const generalInitState = {
  surveyId: '',
  questionId: '',
  isSolutions: false,
  error: false,
  showDiscardKeywordGenerationModal: OECDiscardKeywordGenerationModal.HIDE_KEYWORDS_MODAL,
  showDiscardKeywordsModal: OECDiscardKeywordsModal.HIDE_KEYWORDS_MODAL,
  showUpdateAutotaggingModal: false,
  updateAutotaggingModalSeenCount: 0
};
export const stimuliInitState = {
  stimuli: []
};
export const filtersInitState = {
  searchInput: '',
  sortValue: SORT_BY.DATE,
  filterByTaggedStatus: FILTER_BY_TAGGED_STATUS.ALL,
  filterDisabled: false,
  selectedThemes: [],
  selectedStimuli: [],
  selectedSentiment: []
};
export const responsesInitState = {
  responses: [],
  responsesError: false,
  responsesLoading: false,
  responsesPageSize: RESPONSE_PAGE_SIZE,
  responsesPage: 0,
  responsesCount: 0,
  responsesTotal: 0,
  responsesChanged: false,
  significantChangesResponses: 0,
  showSA: false,
  saStats: {
    negative: 0,
    neutral: 0,
    positive: 0,
    undetected: 0
  }
};
export const feedbackInitState = {
  autotaggingPredictionId: null,
  keywordPredictionId: null,
  jobId: null
};
export const trainingInitState = {
  trainingStep: TRAINING_STEP.KEYWORD_GENERATION,
  unsavedKeywords: [],
  generatedKeywords: [],
  summaryCounts: null,
  trainingError: false,
  trainingComplete: false,
  showTrainingScreen: false,
  shouldRefetchOnOpen: false,
  showTrainingErrorToast: false
};
export const retrainingInitState = {
  trainingStatus: OECTrainingStatus.NOT_TRAINED,
  notEnoughThemesCreated: false,
  notEnoughThemesCreatedStep: OECRetrainStepProgress.HIDE_STEP
};
export const themesInitState = {
  keywords: [],
  keywordsLoading: false,
  keywordsError: false,
  initialThemes: [],
  themes: [],
  themesLoading: false,
  themesError: false,
  themesAdded: false,
  themesDeleted: false,
  themesChanged: false
};
export const themesReuseInitState = {
  previouslyUsedThemes: [],
  suggestedThemes: {},
  useCases: [],
  selectedUseCase: null,
  selectedReusedThemes: []
};
export const OpenEndedCodingInitState = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, generalInitState), themesInitState), retrainingInitState), responsesInitState), stimuliInitState), filtersInitState), trainingInitState), feedbackInitState), themesReuseInitState);